import _regeneratorRuntime from "@babel/runtime/regenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/**
 * the default language to use
 * 
 * @var {string}
 * @author svartoyg
 */
var _languageDefault = null;
/**
 * the fallback language to use
 * 
 * @var {string}
 * @author svartoyg
 */

var _languageFallback = null;
/**
 * two level map with ISO-639-1 code as first key and translation id as second key
 * 
 * @var {Map<string,Map<string,string>>}
 * @author svartoyg
 */

var _data = {};
/**
 * @param {string} language
 * @return Promise<Map<string,string>>
 * @author svartoyg
 */

function retrieveData(_x) {
  return _retrieveData.apply(this, arguments);
}

function _retrieveData() {
  _retrieveData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(language) {
    var json, map;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return import("../loc/".concat(language, ".json"));

          case 3:
            json = _context.sent["default"];
            _context.next = 11;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            _context.next = 10;
            return import("../loc/".concat(language.substr(0, language.indexOf('-')), ".json"));

          case 10:
            json = _context.sent["default"];

          case 11:
            map = {};
            flatten(json, '', map);
            return _context.abrupt("return", map);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  }));
  return _retrieveData.apply(this, arguments);
}

function flatten(tree, prefix, result) {
  for (var _i = 0, _Object$entries = Object.entries(tree); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (typeof value === 'string') {
      result[prefix + key] = value;
    } else {
      flatten(value, prefix + key + '.', result);
    }
  }
}
/**
 * @param {string} languageDefault
 * @param {string} [languageFallback]
 * @author svartoyg
 */


export function initialize(_x2) {
  return _initialize.apply(this, arguments);
}
/**
 * gets a translation by its key for a specific language
 * 
 * @param {string} key
 * @param {string} [languageChosen]
 * @return {string}
 * @author svartoyg
 */

function _initialize() {
  _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(languageDefault) {
    var languageFallback,
        _i3,
        _arr2,
        language,
        data,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            languageFallback = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'en';
            _languageFallback = languageFallback;
            _languageDefault = languageDefault;
            _i3 = 0, _arr2 = [_languageFallback, _languageDefault];

          case 4:
            if (!(_i3 < _arr2.length)) {
              _context2.next = 23;
              break;
            }

            language = _arr2[_i3];

            if (!_data.hasOwnProperty(language)) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("continue", 20);

          case 8:
            console.log('--', 'loading localization data for language "' + language + '" ...');
            data = void 0;
            _context2.prev = 10;
            _context2.next = 13;
            return retrieveData(language);

          case 13:
            data = _context2.sent;
            _context2.next = 19;
            break;

          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](10);
            console.warn(_context2.t0.toString());

          case 19:
            _data[language] = data;

          case 20:
            _i3++;
            _context2.next = 4;
            break;

          case 23:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[10, 16]]);
  }));
  return _initialize.apply(this, arguments);
}

export function translate(key) {
  var languageChosen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _languageDefault;
  var result = undefined;

  for (var _i2 = 0, _arr = [languageChosen, _languageFallback]; _i2 < _arr.length; _i2++) {
    var language = _arr[_i2];

    if (_data.hasOwnProperty(language) && _data[language] !== undefined && _data[language].hasOwnProperty(key)) {
      result = _data[language][key];
      break;
    }
  }

  if (result === undefined) {
    result = '{{' + key + '}}';
  }

  return result;
}